import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  padding: 20px;

  max-height: 274px;
  overflow: auto;

  table {
    border-collapse: collapse;
    width: 100%;
  }

  tbody {
    tr {
      border-bottom: 1px solid #e8eaef;

      transition: 0.2s;

      cursor: pointer;

      &:hover {
        background-color: #f5f5f5;
      }

      &:last-child {
        border: none;
      }
    }
  }

  th {
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
    color: #64728c;
    text-align: left;
  }

  td {
    font-weight: 400;
    line-height: 19px;
    font-size: 14px;
    color: #64728c;
    padding: 10px 10px 10px 0;

    svg {
      width: 6px !important;
      color: var(--primary-color);
    }
  }
`;
